import { render, staticRenderFns } from "./app.mpx?vue&type=template&id=10f88f44&isApp"
import script from "./app.mpx?vue&type=script&lang=js&isApp"
export * from "./app.mpx?vue&type=script&lang=js&isApp"
import style0 from "./app.mpx?vue&type=style&index=0&id=10f88f44&prod&mpxStyleOptions=%7B%22mid%22%3A%22mpx-app-scope%22%7D&lang=css&isApp"


/* normalize component */
import normalizer from "!../../../node_modules/.bun/vue-loader@15.11.1+976731d73d16ee24/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports